export const globalKeyDownHandler = (e: any, onKeyDown: () => any) => {
  if (e.key === 'Enter' || e.code === 'Space') {
    onKeyDown();
  }
};

export default globalKeyDownHandler;
